const km = {
    accepted: ':attribute ត្រូវតែទទួលយក។',
    after: ':attribute ត្រូវតែនៅបន្ទាប់ពី :after។',
    after_or_equal: ':attribute ត្រូវតែមានតម្លៃស្មើរឬលើស :after_or_equal។',
    alpha: ':attribute ត្រូវតែមានតែអក្សរឡាតាំងប៉ុណ្ណោះ។',
    alpha_dash: ':attribute អាចមានតែអក្សរក្រមលេខក៏ដូចជាសញ្ញា (-) និងសញ្ញា (_) ។',
    alpha_num: ':attribute ត្រូវតែជាអក្សរក្រមលេខ។',
    before: ':attribute ត្រូវតែមុន :before។',
    before_or_equal: ':attribute ត្រូវតែស្មើរឺមុន :before_or_equal។',
    between: ':attribute ត្រូវតែស្ថិតនៅចន្លោះ :min និង :max។',
    confirmed: ':attribute ការបញ្ជាក់មិនត្រូវគ្នា។',
    email: ':attribute ទ្រង់ទ្រាយមិនត្រឹមត្រូវ។',
    date: ':attribute មិនមែនជាទ្រង់ទ្រាយកាលបរិច្ឆេទត្រឹមត្រូវទេ។',
    def: ':attribute គុណលក្ខណៈមានកំហុស។',
    digits: ':attribute ត្រូវតែមាន :digits ខ្ទង់។',
    digits_between: ':attribute ត្រូវតែស្ថិតនៅចន្លោះ :min និង :max ខ្ទង់។',
    different: ':attribute និង :different ត្រូវតែមានភាពខុសគ្នា។',
    in: ':attribute ដែលបានជ្រើសរើសមិនត្រឹមត្រូវទេ។',
    integer: ':attribute ត្រូវតែជាចំនួនគត់។',
    hex: ':attribute គួរតែមានទ្រង់ទ្រាយគោលដប់ប្រាំមួយ។',
    min: {
        numeric: ':attribute ត្រូវតែយ៉ាងហោចណាស់ :min។',
        string: ':attribute ត្រូវតែយ៉ាងហោចណាស់ :min តួរអក្សរ។',
    },
    max: {
        numeric: ':attribute មិនអាចធំជាង :max។',
        string: ':attribute មិនអាចធំជាង :max តួរអក្សរ។',
    },
    not_in: ':attribute ដែលបានជ្រើសរើស មិនត្រឹមត្រូវទេ។',
    numeric: ':attribute ត្រូវតែជាលេខ។',
    present: ':attribute ត្រូវតែមាន (ប៉ុន្តែអាចទទេ) ។',
    required: ':attribute ត្រូវតែបញ្ចូលជាដាច់ខាត។',
    required_if: ':attribute ត្រូវការនៅពេលដែល :other គឺ :value។',
    required_unless: ':attribute ត្រូវបានទាមទារពេលណា :other គឺមិនមែនជា :value។',
    required_with: ':attribute ត្រូវបានទាមទារពេលណា :field គឺមិនទទេរ។',
    required_with_all: ':attribute ត្រូវបានទាមទារពេលណា :fields គឺមិនទទេរ។',
    required_without: ':attribute ត្រូវបានទាមទារពេលណា :field គឺទទេរ។',
    required_without_all: ':attribute ត្រូវបានទាមទារពេលណា :fields គឺទទេរ។',
    same: ':attribute និង :same ត្រូវតែដូចគ្នា។',
    size: {
        numeric: ':attribute ត្រូវតែជា :size។',
        string: ':attribute ត្រូវតែជា :size តួរអក្សរ។',
    },
    string: ':attribute ត្រូវតែជាខ្សែអក្សរ។',
    url: ':attribute ទ្រង់ទ្រាយមិនត្រឹមត្រូវ។',
    regex: ':attribute ទ្រង់ទ្រាយមិនត្រឹមត្រូវ។',
    attributes: {
        'form.age': 'អាយុ',
        name: 'ឈ្មោះ',
        form: {
            name: 'ឈ្មោះ',
        },
    },
};
export default km;
